import { Rule } from "antd/lib/form"
import { parseCurrencyInput } from "~Components/currencyInput/config"
import { stringRules } from "~Components/forms/rules/common/string.rules"
import { i18n } from "~Shared/locales/i18n"
import { WorkflowFormValuesInterface } from "../workflowForm/workflowFormValues.interface"

export const createWorkflowRules = () => {
    const amountRule = [
        {
            validator: (_rule, triggerTypeAmount: WorkflowFormValuesInterface["triggerTypes"][0]["amount"]) => {
                const parsedTriggerTypeAmount = parseCurrencyInput(triggerTypeAmount)
                if (parsedTriggerTypeAmount <= 0) {
                    return Promise.reject(new Error(i18n.t("validation:greater.number_short", { min: 0 })))
                }

                if (!parsedTriggerTypeAmount || parsedTriggerTypeAmount === 0) {
                    return Promise.reject(new Error(i18n.t("validation:greater.number_short", { min: 0 })))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>

    return {
        name: [{ required: true, message: i18n.t("validation:required") }, stringRules.allowedMultiLineCharsOnly] as Array<Rule>,
        requestTypes: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
        triggerType: {
            condition: [{ required: true }] as Array<Rule>,
            referenceIds: [{ required: true, message: i18n.t("validation:required") }, { type: "array" }] as Array<Rule>,
            amount: amountRule as Array<Rule>,
            currency: [{ required: true }] as Array<Rule>,
        },
        step: {
            approver: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
            otherApprovers: [{ required: true, message: i18n.t("validation:required") }, { type: "array" }] as Array<Rule>,
            amount: amountRule as Array<Rule>,
            currency: [{ required: true }] as Array<Rule>,
        },
        recalculateApprovalProcessesInProgress: [{ type: "boolean" }] as Array<Rule>,
    }
}
